var _path, _path2, _path3, _path4, _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1eb53a",
    d: "M0 0h1000v500H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0099b5",
    d: "M0 0h1000v250H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M0 160h1000v180H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 170h1000v160H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 80,
    r: 60,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 80,
    r: 60,
    fill: "#0099b5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2 0 0 2 272 128)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0-6v6h3",
    transform: "rotate(18 0 -6)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "scale(-1 1)",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(72)",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(-72)",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(144)",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    y: -24,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    y: -48,
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 24,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 48,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: -48,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: -24,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: -24,
    y: -24,
    width: "100%",
    height: "100%"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUz);
export default __webpack_public_path__ + "static/media/uz.e22893e45004ce7e3cdbd374a07c9e21.svg";
export { ForwardRef as ReactComponent };